
import { CompanyEntity, EMPTY_COMPANY_ENTITY } from "domain/entity/Company/CompanyEntity";
import { CompanyTariffCodeEntity, EMPTY_COMPANY_TARIFF_CODE_ENTITY } from "domain/entity/TariffCode/CompanyTariffCodeEntity";
import { EMPTY_TARIFF_CODE_COMPANY_REQUEST_ENTITY, TariffCodeCompanyRequestEntity } from "domain/entity/TariffCode/TariffCodeCompanyRequestEntity";
import { MenuItem } from "presentation/view/components/OverflowMenuButton";
import { BaseViewChangeSate } from "../BaseViewChangeState";
import { DropdownProps } from "../DropdownProps";

export interface TariffCodeDropdownOptions {
    companyDropdownOptions: DropdownProps[],
    parentTariffCodeDropdownOptions: { [key: string]: DropdownProps[] },
    parentTariffTypeDropdownOptions: DropdownProps[],
}
export interface MasterChangeState extends BaseViewChangeSate {
    tariffCompanyRequest: TariffCodeCompanyRequestEntity,
}

export interface DetailChangeState extends BaseViewChangeSate {
    // companyTariffCodes: CompanyTariffCodeEntity[],
    currentSelectItem: CompanyTariffCodeEntity,
    editingItem: CompanyTariffCodeEntity,
    selecedRows: CompanyTariffCodeEntity[],
    updatedRows: CompanyTariffCodeEntity[],
    isRefresh: boolean,
}

export interface TariffCodeByCompanyModel {
    isLoading: boolean,
    isShowAddPanel: boolean,
    isShowDetail: boolean,
    companyEntityList: CompanyEntity[],
    currentSelectedRow: CompanyEntity,
    selectedRows: CompanyEntity[],
    dynamicOptions: TariffCodeDropdownOptions,
    isBackFromDetail: boolean,
    subMenuItemArray: MenuItem[],
    masterState: MasterChangeState,
    detailState: DetailChangeState,
    companyTariffCodes: CompanyTariffCodeEntity[],
}

export const EMPTY_TARIFF_CODE_BY_COMPANY_MODEL: TariffCodeByCompanyModel = {
    isLoading: false,
    isShowDetail: false,
    isShowAddPanel: false,
    companyEntityList: [],
    currentSelectedRow: { ...EMPTY_COMPANY_ENTITY },
    selectedRows: [],
    dynamicOptions: {
        parentTariffCodeDropdownOptions: {},
        companyDropdownOptions: [],
        parentTariffTypeDropdownOptions: [],
    },
    isBackFromDetail: false,
    subMenuItemArray: [],
    masterState: {
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        },
        tariffCompanyRequest: EMPTY_TARIFF_CODE_COMPANY_REQUEST_ENTITY
    },
    detailState: {
        //companyTariffCodes: [],
        currentSelectItem: EMPTY_COMPANY_TARIFF_CODE_ENTITY,
        isSliderOpen: false,
        isTabularDataActive: false,
        isAdd: false,
        isRead: false,
        isEditable: false,
        isSaveClicked: false,
        lastEditRowId: "",
        isSelected: false,
        slider: {
            isAdd: false,
            isRead: false,
            isEditable: false
        },
        selecedRows: [],
        editingItem: EMPTY_COMPANY_TARIFF_CODE_ENTITY,
        updatedRows: [],
        isRefresh: false
    },
    companyTariffCodes: []
}